import { useEffect, useState } from 'react';
import Toggle from '../../Components/Toggle/Toggle';
import PlusIcon from "../../Assets/PlusIcon/Add.svg";
import DownloadIcon from "../../Assets/Download.svg";
import Products from './Components/Products/Products';
import { useDispatch } from 'react-redux';
import { fetchInventoryProducts, fetchSizeCharts, setModal, setSelectedVariant } from '../../Features/inventoryManagementSlice';
import Modal from './Components/Modals/Modal';
import Inventory from './Components/Inventory/Inventory';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loading from '../../Components/Loading/Loading';
import Error from '../../Components/Error/Error';

function InventoryManagement() {
    const dispatch = useDispatch();
    const location = useLocation();

    const { loading } = useSelector((state) => state.inventoryManagement.products);

    const [activeSection, setActiveSection] = useState('products');

    const handleSectionSelect = (e) => {
        setActiveSection(e.target.id);
    }

    const handleImport = () => {
        dispatch(setModal('import-home'));
    }

    const handleAddProduct = () => {
        dispatch(setModal('add-product-select'));
    }

    const handleBulkUpdateClick = () => {
        dispatch(setModal('bulk-update-home'));
    }

    useEffect(() => {
        dispatch(fetchInventoryProducts());
        dispatch(fetchSizeCharts());
        dispatch(setSelectedVariant({}));
        // eslint-disable-next-line
    }, []);

    if(loading === 'loading') {
        return <Loading />
    }

    if(loading === 'failed') {
        return <Error />
    }

    return (
        <div className="w-full h-full overflow-y-scroll pb-36 outline-none">
            <div className="flex items-center justify-between gap-6 m-[20px_19px_24px_20px]">
                <h1 className="text-[#121212] font-bold text-2xl select-none">Inventory Management</h1>
            </div>

            <div className='flex items-center justify-between gap-3 mt-4 mx-5'>
                <Toggle 
                    items={{
                        firstItem: 'Products',
                        secondItem: 'Inventory',
                        firstItemID: 'products',
                        secondItemID: 'inventory', 
                        activeList: activeSection
                    }} 
                    onClick={handleSectionSelect} 
                />

                {
                    activeSection === 'products' && 
                    <div className="flex items-center gap-3 select-none">
                        <Link to={`${location.pathname}/size-charts`} className='text-[#1055EB] text-base font-semibold'>Size Charts</Link>

                        <button onClick={handleImport} className='outline-none flex items-center gap-[2px] p-[8px_16px_8px_11px] font-semibold text-base text-[#808080]'>
                            <div className="size-6 flex items-center justify-center">
                                <img src={DownloadIcon} alt="" />
                            </div>

                            Import
                        </button>

                        <button onClick={handleAddProduct} className='outline-none flex items-center gap-[2px] p-[8px_16px_8px_10px] bg-primaryColor hover:bg-primaryAccent font-semibold text-base text-buttonText rounded'>
                            <div className="size-6 flex items-center justify-center">
                                <img src={PlusIcon} alt="" />
                            </div>

                            Add Product
                        </button>
                    </div>
                }

                {
                    activeSection === 'inventory' && 
                    <button onClick={handleBulkUpdateClick} className='outline-none flex items-center gap-[2px] p-[8px_16px_8px_10px] bg-primaryColor hover:bg-primaryAccent font-semibold text-base text-buttonText rounded'>
                        <div className="size-6 flex items-center justify-center">
                            <img src={PlusIcon} alt="" />
                        </div>

                        Bulk Update
                    </button>
                }
            </div>

            <div className="flex flex-col">
                {activeSection === 'products' && <Products />}

                {activeSection === 'inventory' && <Inventory />}
            </div>

            <Modal />
        </div>
    );
}

export default InventoryManagement;
